import styled from 'styled-components';

export const PanelWrapperStyled = styled.div`
  width: 380px;
  max-height: 560px;
  display: flex;
  flex-direction: column;
  background: ${p => p.theme.colors.white};
  border-radius: 12px;
  box-shadow: 0 8px 32px ${p => p.theme.colors.cardShadow}, 0 2px 8px ${p => p.theme.colors.cardShadowMd};
  overflow: hidden;
`;

export const PanelHeaderStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 14px;
  border-bottom: 1px solid ${p => p.theme.colors.borderLight};
`;

export const PanelTitleStyled = styled.span`
  color: ${p => p.theme.colors.dark};
`;

export const PanelBodyStyled = styled.div`
  flex: 1;
  overflow-y: auto;

  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb { background: ${p => p.theme.colors.border}; border-radius: 2px; }

  .ant-list-item {
    padding: 0 !important;
    border-block-end: none !important;
  }
`;

export const GroupLabelStyled = styled.div`
  padding: 10px 20px 4px;
  color: ${p => p.theme.colors.textLight};
`;

export const EmptyStateStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 56px 24px;
  gap: 12px;

  p { margin: 0; color: ${p => p.theme.colors.textLight}; }
`;

export const NotifRowStyled = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 20px;
  border-bottom: 1px solid ${p => p.theme.colors.borderLight};
  cursor: pointer;

  &:last-child { border-bottom: none; }
  &:hover { background: ${p => p.theme.colors.secondary}; }
`;

export const NotifTextBlockStyled = styled.div`
  flex: 1;
  min-width: 0;
`;

export const NotifTitleRowStyled = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 2px;
`;

export const NotifTitleStyled = styled.span`
  color: ${p => p.theme.colors.dark};
  line-height: 1.4;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const NotifTimeStyled = styled.span`
  color: ${p => p.theme.colors.textLight};
  white-space: nowrap;
  flex-shrink: 0;
`;

export const PanelFooterStyled = styled.div`
  padding: 10px 20px;
  border-top: 1px solid ${p => p.theme.colors.borderLight};
  display: flex;
  justify-content: center;
`;